//core
import React, { useState } from "react";
import arePropsEqual from "react-fast-compare";
import { useTranslation } from "react-i18next";
import { UndoOutlined } from "@mui/icons-material";

//components
import ActionIconButton from "../../../../../UI/Buttons/ActionIconButton";
import MuiModal from "../../../../../UI/MuiModal";
import ReturnPlayerModal from "../ReturnPlayerModal"; 

export interface ITableActions {
  id: number;
  data: any;
}

const TableActions: React.FC<ITableActions> = ({ data }) => {
  const { t } = useTranslation();
  const [showRestoreModal, setShowRestoreModal] = useState(false);

  const canRestoreRow = data?.is_player_statistics_restorable === true;
  const compositePlayerId = data?.composite_player_id || null;
  const filterType = data?.filter_type || null;

  const handleToggleRestoreModal = (state: boolean) => {
    setShowRestoreModal(state);
  };

  const handleClickRestore = () => {
    if (canRestoreRow && compositePlayerId) {
      setShowRestoreModal(true);
    }
  };

  return (
    <>
      <ActionIconButton
        text={t(
          canRestoreRow
            ? "admin.reports.full_report.actions.restore_player_statistics"
            : "admin.reports.full_report.actions.restore_player_statistics_unavailable"
        )}
        icon={<UndoOutlined fontSize="small" color={canRestoreRow ? "primary" : "disabled"} />}
        onClick={handleClickRestore}
        disabled={!canRestoreRow || !compositePlayerId}
      />

      <MuiModal
        width={520}
        open={showRestoreModal}
        closeOnOutside={false}
        setToggleModal={handleToggleRestoreModal}
      >
        <ReturnPlayerModal
          setToggleModal={handleToggleRestoreModal}
          compositePlayerId={compositePlayerId}
          filterType={data?.filter_type || null}
        />
      </MuiModal>
    </>
  );
};

export default React.memo(TableActions, arePropsEqual);
